// export const MEM_PATH = 'assets/mem/mem.js';
export const MEM_PATH = 'assets/mem/design.js';
export const MEM_LAYOUT_PATH = 'assets/mem/design-layout.js';
export const MEM_INPUT_PATH = 'assets/mem/design-inputs.js';
